import axios from "axios";
import "./request_interceptor";



//const end_point1 = "http://192.168.30.225:88/api/eadmin/";
//const end_point1 = "https://preprodb.portailachats.ma/api/eadmin/";

const end_point1 = process.env.REACT_APP_API_URL + "/api/eadmin/";

////////////////////////////////////////////////////
////
////////////////////////////////////////////////////

export const company_admin_profil = async (id_admin) => {
  return await axios.get(end_point1 + "company_admin_profil/" + id_admin);
};

export const update_company_admin_profil = async (data) => {
  return await axios.post(end_point1 + "update_company_admin_profil", data);
};

export const create_service = async (data) => {
  return await axios.post(end_point1 + "create_service", data);
};

export const create_auditor = async (data) => {
  return await axios.post(end_point1 + "create_auditor", data);
};

export const get_services = async (service_role, filter, page) => {
  return await axios.get(
    end_point1 + "get_services/" + service_role + "/" + filter + "?page=" + page
  );
};

export const get_all_services = async () => {
  return await axios.get(end_point1 + "get_all_services");
};

export const get_auditors_for_cadmin = async (
  auditors_departement,
  filter,
  page
) => {
  return await axios.get(
    end_point1 +
      "get_auditors/" +
      auditors_departement +
      "/" +
      filter +
      "?page=" +
      page
  );
};

export const update_service_req = async (data) => {
  return await axios.post(end_point1 + "update_service", data);
};

export const archive_service = async (data) => {
  return await axios.post(end_point1 + "archive_service", data);
};

export const archive_auditor = async (data) => {
  return await axios.post(end_point1 + "archive_auditor", data);
};

export const add_categorie = async (data) => {
  return await axios.post(end_point1 + "add_categorie", data);
};

export const get_all_categories = async () => {
  return await axios.get(end_point1 + "get_all_categories");
};

export const get_categories = async (filter, page) => {
  return await axios.get(
    end_point1 + "get_categories/" + filter + "?page=" + page
  );
};

export const archive_categorie = async (data) => {
  return await axios.post(end_point1 + "archive_categorie", data);
};

export const add_contract = async (data) => {
  return await axios.post(end_point1 + "add_contract", data);
};

export const get_contracts_for_cadmin = async (filter, page) => {
  return await axios.get(
    end_point1 + "get_contracts_for_cadmin/" + filter + "?page=" + page
  );
};

export const archive_contract = async (data) => {
  return await axios.post(end_point1 + "archive_contract", data);
};

////////////////////////////////////////////////////
//// Workflows
////////////////////////////////////////////////////

export const get_offersCalls_props = async () => {
  return await axios.get(end_point1 + "get_offersCalls_props");
};

////////////////////////////////////////////////////
//// doc
////////////////////////////////////////////////////

export const create_doc = async (data) => {
  return await axios.post(end_point1 + "create_doc", data);
};

export const get_docs = async (filter) => {
  return await axios.get(end_point1 + "get_docs/" + filter);
};

////////////////////////////////////////////////////
//// Directions_departments
////////////////////////////////////////////////////

export const get_departments = async (page) => {
  return await axios.get(end_point1 + "get_departments?page=" + page);
};
export const get_all_departments = async () => {
  return await axios.get(end_point1 + "get_all_departments");
};
export const get_department_by_id = async (id) => {
  return await axios.get(end_point1 + "get_department_by_id/" + id);
};
export const create_department = async (data) => {
  return await axios.post(end_point1 + "create_department", data);
};
export const update_department = async (data) => {
  return await axios.post(end_point1 + "update_department", data);
};

export const get_all_directions = async (page) => {
  return await axios.get(end_point1 + "get_all_directions");
};

export const get_directions = async (page) => {
  return await axios.get(end_point1 + "get_directions?page=" + page);
};
export const create_direction = async (data) => {
  return await axios.post(end_point1 + "create_direction", data);
};
export const get_direction_by_id = async (id) => {
  return await axios.get(end_point1 + "get_direction_by_id/" + id);
};
export const update_direction = async (data) => {
  return await axios.post(end_point1 + "update_direction", data);
};

////////////////////////////////////////////////////
//// Referentiel_list
////////////////////////////////////////////////////

export const get_values_lists = async (page) => {
  return await axios.get(end_point1 + "get_values_lists?page=" + page);
};

export const get_values_list_by_type = async (type) => {
  return await axios.get(end_point1 + "get_values_list_by_type/" + type);
};

export const add_value_to_list = async (data) => {
  return await axios.post(end_point1 + "add_value_to_list", data);
};

export const update_value_from_list = async (data) => {
  return await axios.post(end_point1 + "update_value_from_list", data);
};

////////////////////////////////////////////////////////////////
//////////////////// Import Files
////////////////////////////////////////////////////////////////

export const upload_suppliers_catalogues = async(data) => {
    return await axios.post(end_point1+"upload_suppliers_catalogues",data);
}


////////////////////////////////////////////////////////////////
//////////////////// DA workflow
////////////////////////////////////////////////////////////////

export const get_da_wf_process_steps = async()=>{
    return await axios.get(end_point1+"get_da_wf_process_steps");
}

export const create_da_wf_step = async(data)=>{
    return await axios.post(end_point1+"create_da_wf_step",data);
}

export const update_da_wf_step = async (data)=>{
    return await axios.post(end_point1+"update_da_wf_step",data);
}

export const activate_da_wf_steps = async (data)=>{
    return await axios.post(end_point1+"activate_da_wf_steps",data);
}